var _path, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 90,
    viewBox: "0 0 180 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H172C176.418 0 180 3.58172 180 8V82C180 86.4183 176.418 90 172 90H8C3.58172 90 0 86.4183 0 82V8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2119_815",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 179,
    height: 88
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 179,
    height: 88,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2119_815)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2119_815)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.996 30.7778H170V59.2223H119.996V30.7778ZM139.008 37.3153H135.536V52.6812H154.46V49.6516H139.008V37.3153Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9998 30.7778H115.004V59.2223H64.9998V30.7778ZM79.4746 40.345H88.2626V52.6848H91.7376V40.345H100.526V37.3153H79.4746V40.345Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 30.7778H60.0042V59.2223H10V30.7778ZM37.5281 37.3153H24.2032V52.6848H27.6747V47.3071H34.6422L40.7843 52.6848H45.7974L39.2638 47.1072C42.1496 46.6897 43.843 44.9091 43.843 42.2541C43.843 39.1602 41.5851 37.3153 37.5281 37.3153ZM40.2622 42.2969C40.2622 43.7243 39.2214 44.4273 37.073 44.4273V44.4237H27.6747V40.1879H37.073C39.2214 40.1879 40.2622 40.8695 40.2622 42.2969Z",
    fill: "#455A64"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2119_815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 28.4444,
    fill: "white",
    transform: "translate(10 30.7778)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtl);
export default __webpack_public_path__ + "static/media/rtl.35f8bfe8282297d02c3bbef9c46c6a8e.svg";
export { ForwardRef as ReactComponent };